<template>
  <OurCard class="dealer-ranking-card mb-4" border-radius="sm" @click.native="onClick">
    <div class="flex min-w-0 items-center gap-3">
      <span class="text-lg font-bold text-gray-900">{{ item.place }}</span>
      <OurAvatar :user-name="item.customerName" size="lg" rounded="full" />
      <div class="min-w-0">
        <div class="font-medium text-gray-900">{{ item.customerName }}</div>
        <div class="text-sm text-gray-500">{{ $t("page.users.id") }}: {{ item.customerId }}</div>
      </div>
    </div>

    <div class="mt-3 grid gap-2">
      <OurTextField :label="$t('promotions.dealersList.dealerLevel')">
        <BonusProgramLevelBadge :level="item.dealerLevel" />
      </OurTextField>
      <OurTextField :label="$t('promotions.dealersList.incentiveLevel')">
        <IncentiveLevelProgressCell
          :level="item.incentiveLevel.level"
          :progress-percent="item.incentiveLevel.progressPercent"
        />
      </OurTextField>
      <OurTextField :label="$t('promotions.dealersList.shipmentsSum')">
        <OurMoney weight="regular" size="sm" :sum="item.shipmentsSum" currency-symbol="$" />
      </OurTextField>
    </div>
  </OurCard>
</template>

<script>
import BonusProgramLevelBadge from "./BonusProgramLevelBadge.vue";
import IncentiveLevelProgressCell from "./IncentiveLevelProgressCell.vue";

export default {
  name: "DealerRankingCard",

  components: {
    BonusProgramLevelBadge,
    IncentiveLevelProgressCell,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    icons: () => ({
      Arrow: require("@/components/_bit/IconSvg/icons/Arrow-right.svg"),
    }),
  },

  methods: {
    onClick() {
      this.$emit("click", this.item.customerId);
    },
  },
};
</script>

<style lang="postcss" scoped>
.dealer-ranking-card {
  @apply cursor-pointer;
}
</style>
